import {createAction} from 'redux-act'

export const switchToGraph = createAction(
  'Switch to graph'
)
export const switchToTree = createAction(
  'Switch to tree'
)
